import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeedComponent } from './seed.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SeedComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  exports: [SeedComponent],
})
export class SeedModule {}
